import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import { RouterChildContext } from "react-router";
import { AppLocation } from "src/redux/main/mainReducer";
import { SubscriptionEntitlements } from "./subscriptionUtils";
import { openSettingsModal } from "../SettingsModal/methods";
import { SettingsContext, SettingsTab } from "../SettingsModal/enums";
import { getSubscriptionEntitlement } from "src/redux";
import { getRoute, ROUTES } from "src/utils/ROUTES";

export const useCheckFeatureAccess = (
  feature: SubscriptionEntitlements | null | undefined,
) => {
  const { identity, activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );
  const { entitlements, entitlementsLoading } = useSelector(
    (state: RootState) => state.subscriptionReducer,
  );

  const { subscriptionData } = identity || {};

  const dispatch = useDispatch();

  useEffect(() => {
    if (!feature || !subscriptionData || entitlementsLoading[feature]) return;
    dispatch(getSubscriptionEntitlement(activeWorkspaceUuid, feature));
  }, [activeWorkspaceUuid, feature, subscriptionData]);

  if (!feature || !subscriptionData) return true;

  return entitlements[feature] ?? false;
};

const goToSubscriptionUrl = (
  history: RouterChildContext["router"]["history"],
  pathname: string,
) => {
  if (window.location.pathname.includes("/subscription")) {
    history.push({ pathname, search: "" });
  } else {
    window.sessionStorage.setItem("subscriptionEntryUrl", window.location.href);
    window.location.href = window.location.origin + pathname;
  }
};

export const openSelectPlanScreen = (
  history: RouterChildContext["router"]["history"],
  workspaceUuid: string,
) => {
  goToSubscriptionUrl(
    history,
    `/workspace/${workspaceUuid}/subscription/select-plan`,
  );
};

export const openCheckoutScreen = (
  history: RouterChildContext["router"]["history"],
  workspaceUuid: string,
  planId: string,
) => {
  goToSubscriptionUrl(
    history,
    `/workspace/${workspaceUuid}/subscription/checkout/${planId}`,
  );
};

export const openUnlockAddonsScreen = (
  history: RouterChildContext["router"]["history"],
  workspaceUuid: string,
) => {
  goToSubscriptionUrl(
    history,
    `/workspace/${workspaceUuid}/subscription/unlock-addons`,
  );
};

export const closeSubscriptionPage = (
  history: RouterChildContext["router"]["history"],
  workspaceUuid: string | undefined,
) => {
  const entryUrl = window.sessionStorage.getItem("subscriptionEntryUrl");
  if (entryUrl) {
    window.location.href = entryUrl;
  } else {
    history.push(getRoute(ROUTES.HOMEPAGE, { wsWorkspaceUuid: workspaceUuid }));
    openSettingsModal(
      history,
      AppLocation.Navbar,
      SettingsContext.Workspace,
      SettingsTab.Subscription,
    );
    history.go(0);
  }
};
